import React, { useState } from "react";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { useLanguage } from "../../../../contexts/LanguageContext";

const CurrentAccountReportFilters = ({
  handleApplyFilters,
  handleResetFilters,
  customerDropdown,
}) => {
  const { th } = useLanguage();
  const [open, setOpen] = useState(true);

  const [localFilters, setLocalFilters] = useState({
    startDate: null,
    endDate: null,
  });

  const handleApply = () => {
    handleApplyFilters(localFilters);
  };

  const handleReset = () => {
    setLocalFilters({ startDate: null, endDate: null });
    handleResetFilters();
  };

  return (
    <div className="generic-table-filter mb-2">
      <div className="grid">
        <div className="col-12 md:col-6 flex justify-content-start">
          <Button
            icon="pi pi-filter"
            label={th("filter.advancedFilter") || "Gelişmiş Filtre"}
            onClick={() => setOpen((p) => !p)}
            outlined={!open}
            style={{ minWidth: "120px" }}
            type="button"
          />
        </div>
      </div>

      {open && (
        <div className="mt-3">
          <Divider />
          <div className="text-xl font-medium mb-3">
            {th("filter.advancedFilters") || "Gelişmiş Filtreler"}
          </div>

          <div className="grid">
            <div className="col-12 md:col-6 lg:col-3">
              <div className="field mb-2 p-1">
                <label htmlFor="reportCustomer" className="block mb-1 text-sm">
                  {th("preAccounting.customer") || "Müşteri"}
                </label>
                <Dropdown
                  key={customerDropdown.key}
                  id="reportCustomer"
                  value={customerDropdown.value}
                  onChange={(e) => customerDropdown.onChange(e.value)}
                  options={customerDropdown.options}
                  optionLabel="label"
                  optionValue="value"
                  placeholder={customerDropdown.placeholder}
                  className="w-full"
                  filter
                  filterTemplate={customerDropdown.filterTemplate}
                  showClear
                  loading={customerDropdown.loading}
                  appendTo="self"
                  emptyMessage={customerDropdown.emptyMessage}
                  onShow={customerDropdown.onShow}
                />
              </div>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
              <div className="field mb-2 p-1">
                <label className="block mb-1 text-sm">
                  {th("currentAccountReport.startDate") || "Başlangıç Tarihi"}
                </label>
                <Calendar
                  value={localFilters.startDate}
                  onChange={(e) =>
                    setLocalFilters((p) => ({ ...p, startDate: e.value }))
                  }
                  dateFormat="dd/mm/yy"
                  showIcon
                  placeholder={
                    th("currentAccountReport.startDate") || "Başlangıç Tarihi"
                  }
                  className="w-full"
                />
              </div>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
              <div className="field mb-2 p-1">
                <label className="block mb-1 text-sm">
                  {th("currentAccountReport.endDate") || "Bitiş Tarihi"}
                </label>
                <Calendar
                  value={localFilters.endDate}
                  onChange={(e) =>
                    setLocalFilters((p) => ({ ...p, endDate: e.value }))
                  }
                  dateFormat="dd/mm/yy"
                  showIcon
                  placeholder={
                    th("currentAccountReport.endDate") || "Bitiş Tarihi"
                  }
                  className="w-full"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-content-start mt-3">
            <Button
              label={th("filter.reset") || "Sıfırla"}
              icon="pi pi-refresh"
              className="p-button-outlined mr-2"
              onClick={handleReset}
              type="button"
            />
            <Button
              label={th("filter.apply") || "Uygula"}
              icon="pi pi-check"
              onClick={handleApply}
              type="button"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrentAccountReportFilters;